import { META } from 'app/constants';
import Meta from 'endpoints/meta';

const setAppVersion = (payload) => {
  return {
    type: META.SET_VERSION,
    payload,
  };
};

const setAppVersionThunk = () => (dispath, getState) => {
  Meta.getAppVersion()
    .then((data) => {
      dispath(setAppVersion(data));
    })
    .catch((err) => console.error('[setAppVersionThunk]:', err));
};

export default {
  setAppVersionThunk,
};
